import ApiService from '@/services/core/api.service'

const CategoryService = {
  async get (query) {
    return ApiService.get(`admin/categories?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/categories', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/categories/${payload.id}`, payload)
  }
}

export default CategoryService
